import { Button, Modal, Form, Row, Col, Input, message, Checkbox } from "antd";
import { useEffect, useState } from "react";
import patchDataRoad from "../../../../services/patchDataRoad";

type RequiredMark = boolean | "optional";

export default function UpdateSource({
  isVisible,
  setVisible,
  selected,
  refetch,
}: any) {
  const [isActive, setActive] = useState(selected?.isActive);
  const [isLoading, setLoading] = useState(false);
  const [requiredMark, setRequiredMarkType] =
    useState<RequiredMark>("optional");

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const uri = `sources/${selected?._id}`;
    const data = { isActive, ...values };
    const response = await patchDataRoad(data, uri);

    if (response.success) {
      refetch();
      message.success("Source updated successfully");
    } else {
      message.error("Sorry, Something went wrong");
      setLoading(false);
      return;
    }
    setLoading(false);
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
    setActive(selected.isActive);
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Update Source"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updateSource"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateSource"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
        initialValues={{ requiredMarkValue: requiredMark }}
        requiredMark={requiredMark}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              label="Source"
              initialValue={selected?.name}
              rules={[
                {
                  required: true,
                  message: "Please enter source name",
                },
              ]}
            >
              <Input placeholder="Source" />
            </Form.Item>
          </Col>
        </Row>
        <div className="my-2">
          <Checkbox checked={isActive} onChange={() => setActive(!isActive)}>
            Active
          </Checkbox>
        </div>
      </Form>
    </Modal>
  );
}
